interface IDocumento {
    Nombre: String;
    Codigo: String;
}

export class Documento implements IDocumento {
    Nombre = "";
    Codigo = "";
    constructor() {}
};


// WEBPACK FOOTER //
// C:/Workspaces/Redjurista/MAIN/Source/Asterysco.AJ.Lawtheque/GUI/Angular Components/findarticles/src/app/models/documento.ts